import React from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'

interface HasConversionPermissionProps {
  children: React.ReactNode
}

const HasConversionPermission = ({ children }: HasConversionPermissionProps) => {
  const selectedRegion = useSelector((state: IRootReducerState) => state.region.selectedRegion)
  const isNLRegion = selectedRegion.startsWith('nl') || selectedRegion.includes('.nl.')

  // only dutch environment has permission to access conversion snapshots in S3
  // other environments return an api error
  const hasPermission = isNLRegion || selectedRegion === 'localhost'

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{hasPermission ? children : null}</>
}

export default HasConversionPermission
